import React from 'react';
import Card from '../base/Card';
import Button from '../base/Button';
import './PlaceholderStyles.css';

function GoalsPlaceholder() {
  return (
    <div className="placeholder-container">
      <Card className="placeholder-card feature-placeholder">
        <div className="placeholder-icon">🎯</div>
        <h2 className="placeholder-title title-1">Goals</h2>
        <p className="placeholder-description body-text">
          Set meaningful goals and track your progress over time.
          Connect your daily focus sessions to larger objectives.
        </p>
        <div className="placeholder-features">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Daily, weekly, monthly goals</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Progress tracking</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Milestone celebrations</span>
          </div>
        </div>
        <div className="placeholder-actions">
          <Button variant="primary" showArrow disabled>
            Set Your First Goal
          </Button>
        </div>
        <p className="placeholder-note caption">
          Ready for implementation. Build your goal tracking system here.
        </p>
      </Card>
    </div>
  );
}

export default GoalsPlaceholder;








